import Keycloak from "keycloak-js";
import { getTenant } from "./api/ApiUtils";

const keycloak = new Keycloak({
  url: window.env.REACT_APP_KEYCLOAK_URL || process.env.REACT_APP_KEYCLOAK_URL,
  realm: getTenant(),
  clientId: "react-loyalty",
});

keycloak.onTokenExpired = () => {
  keycloak.updateToken(30).catch(() => {
    keycloak.logout();
  });
};

export default keycloak;
